import React, { useState } from 'react';
import ReactTable from "react-table";
import treeTableHOC from "react-table/lib/hoc/treeTable";
import {
  Card,
  CardBody,
  CardTitle,
  Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Row, Col,
  ButtonGroup,
} from 'reactstrap';
import "react-table/react-table.css";
import * as data from "../tables/reactable-data";
import Switch from "react-switch";
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import avatar from '../../assets/images/users/3.jpg'
import Select, { components } from 'react-select'
import countryList from 'react-select-country-list'
// import { SelectTimezone } from 'react-select-timezone';
import TimeZoneField from '../../components/people/timeZoneField'
import { auth } from '../../Api'
import ImageUploader from 'react-images-upload';
import { baseURL, baseImgURL } from '../../Api/BaseApi';
import { getName } from 'country-list';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { resellerFormProblem, resellerMissingNotice } from '../../utils/resellers'
import { formatServerMessage } from '../../utils/serverErrors'
import { leaveForm } from '../../utils/formReturn'
import EditButtons, { markChanged, withChange } from '../../components/forms/editButtons'

const TreeTable = treeTableHOC(ReactTable);

export function CountryFlag(props) {
  return (
    <span
      className={"flag-icon flag-icon-" + props.code}
      style={{ fontSize: props.size || "30px" }}
    />
  );
}

export const CountryFlagSelectOption = props => {
  return (
    <components.Option {...props}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <CountryFlag size={props.flagSize} code={props.value.toLowerCase()} />
        {props.label}
      </div>
    </components.Option>
  );
};

export const CountryFlagValueContainer = ({ children, ...props }) => {
  const code = (props.hasValue && props.getValue()[0].value) || false;

  return (
    <div style={{ display: "flex", flexGrow: 1 }}>
      {(code && <CountryFlag code={code.toLowerCase()} />) || null}
      <components.ValueContainer {...props}>
        {children}
      </components.ValueContainer>
    </div>
  );
};

const styles = {
  valueContainer: (base, state) => {
    const height = "35px";
    return { ...base, height };
  }
};

class CompanyView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      open: false,
      modal: false,
      showAlert: false,
      showResult: false,
      alertMessage: '',
      obj: {},
      jsonData: data.dataTable,
      data: data.makeData(),
      treedata: data.treedata,
      options: countryList().getData(),
      // First name (users.name), last name (sname) and the reseller's own company name (reseller_company)
      nameValue: '',
      snameValue: '',
      companyValue: '',
      // What an older reseller still lacks ('last name', 'company name'), from the server
      missing: [],
      emailValue: null,
      phoneValue: null,
      countryValue: null,
      timeValue: '',
      password: '',
      center: {
        lat: 59.95,
        lng: 30.33
      },
      showAlert: false,
      showResult: false,
      zoom: 11,
      pictures: [],
      avatarUrl: '/storage/avatar.jpg',
      resellerId: null,
      verify:true
    };
    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }

  componentDidMount() {
    let resellerId = localStorage.getItem('resellerId')
    console.log("resellerId:", resellerId)
    this.setState({
      resellerId: resellerId
    })
    if (resellerId != null)
      auth.getReseller(resellerId)
        .then((res) => {
          if (res.data.code == 200) {
            let companyData = res.data.message.users[0];
            console.log("compmnayData:", companyData)
            this.setState({
              nameValue: companyData.name || '',
              snameValue: companyData.sname ? companyData.sname.trim() : '',
              companyValue: companyData.reseller_company || '',
              missing: companyData.missing || [],
              // The saved zone, kept unless the country changes (a country with several zones is not worked out)
              timeValue: companyData.timezone ? { value: companyData.timezone, label: companyData.timezone } : '',
              emailValue: companyData.email,
              phoneValue: companyData.phonenumber,
              avatarUrl: companyData.avatar,
              countryValue: { value: companyData.countrycode, label: getName(companyData.countrycode) }
              // locationData:res.data.message.locations
            })
          }
        });
  }

  onDrop(picture) {
    var req = {}
    req.file = picture[0]
    console.log("req:", req);
    var that = this;
    auth.upload(req)
      .then((res) => {
        if (res.data.code == 201) {
          that.setState({
            avatarUrl: res.data.url
          })
        }
      })
    this.setState({
      pictures: this.state.pictures.concat(picture),
    });
  }

  toggle() {
    this.setState({
      showAlert: !this.state.showAlert
    });
  }
  changeCountry = value => {
    this.setState({ countryValue: value });
  };
  changeTimezone = value => {
    this.setState({ timeValue: value });
  }
  onSave = (event) => {
    event.preventDefault();
    let { emailValue, phoneValue, countryValue, nameValue, snameValue, companyValue,
      password, avatarUrl, resellerId,verify } = this.state
    this.setState({ showResult: false });
    const nameProblem = resellerFormProblem({ first: nameValue, last: snameValue, company: companyValue })
    if (nameProblem) {
      this.setState({ showAlert: true, showResult: false, alertMessage: nameProblem })
      return
    }
    // A new reseller has no password yet, so one must be entered (server requires at least 6 characters)
    if (resellerId == null && (!password || password.length < 6)) {
      this.setState({
        showAlert: true,
        showResult: false,
        alertMessage: 'Please enter a Password of at least 6 characters.'
      })
      return
    }
    var req = {}
    req.name = nameValue.trim()
    req.sname = snameValue.trim()
    req.reseller_company = companyValue.trim()
    req.phonenumber = phoneValue
    req.email = emailValue
    // On edit, a blank password means "keep the current one", so only send it when typed
    if (password) {
      req.password = password
      req.password_confirmation = password
    }
    // Worked out from the country ("GMT" was sent before: it has no summer time and is refused now)
    if (!this.state.timeValue || !this.state.timeValue.value) {
      this.setState({ showAlert: true, showResult: false, alertMessage: 'Please choose the time zone: the country has several.' })
      return
    }
    req.timezone = this.state.timeValue.value
    req.avatar = avatarUrl
    if (countryValue != null) {
      req.countrycode = countryValue.value
    }
    req.level = "b"
    req.verify = verify
    var that = this;
    if (resellerId != null) {
      req.id = resellerId
      // auth/company/update answers 200 on success (register is the one that answers 201)
      auth.updateCompany(req)
        .then((res) => {
          if (res.data.code == 200) {
            // Back to the page the form was opened from, or the resellers list (a reseller has no page of its own)
            leaveForm(that.props.history, '/resellers')
          }
          else {
            that.setState({
              showAlert: true,
              showResult: false,
              alertMessage: formatServerMessage(res.data.message, 'Update failed. Please try again.')
            })
          }
        })
        .catch(() => {
          that.setState({
            showAlert: true,
            showResult: false,
            alertMessage: 'Could not reach the server. Please try again.'
          })
        });
    }
    else {
      auth.register(req)
        .then((res) => {
          let alertMessage = "";
          if (res.data.message != null) {
            if (res.data.code == 400) {
              if (res.data.message.email != null) {
                alertMessage += 'The email already exists.\n'
              }
              if (res.data.message.phonenumber != null) {
                alertMessage += 'This phone number already exists\n'
              }
              if (alertMessage === '') {
                alertMessage = formatServerMessage(res.data.message, 'Could not create the reseller. Please check the form.')
              }
              that.setState({
                showAlert: true,
                showResult: false,
                alertMessage: alertMessage
              })
            }
            else if (res.data.code == 201) {
              // Back to the page the form was opened from, or the resellers list
              leaveForm(that.props.history, '/resellers')
            }

          }
        });
    }
  }

  setPhoneNumber = (event) => {
    console.log("event of phone:", event)
    this.setState({
      phoneValue: event
    })
  }

  handleChange = (event) => {
    console.log(["event.valu:", event.target.value, event.target.name])
    switch (event.target.name) {
      case "name":
        this.setState({
          nameValue: event.target.value
        })
        break;
      case "sname":
        this.setState({
          snameValue: event.target.value
        })
        break;
      case "reseller_company":
        this.setState({
          companyValue: event.target.value
        })
        break;
      case "email":
        this.setState({
          emailValue: event.target.value
        })
        break;
      case "phone":
        this.setState({
          phoneValue: event.target.value
        })
        break;
      case "password":
        this.setState({
          password: event.target.value
        })
        break;
    }
  }

  // Exit edit page / Discard changes: leaves without saving, back where the form was opened from (or the record's page)
  exitForm = () => {
    const id = this.props.match && this.props.match.params ? this.props.match.params.id : null
    leaveForm(this.props.history, (() => '/resellers')(id))
  }

  render() {
    let { avatarUrl, resellerId } = this.state
    console.log("rese;;erId:", resellerId)
    return <div>
      <Card>
        {/* <CompanyMenu></CompanyMenu> */}
        <Row className="toolbar up-card-title">
          <div className="b-title"><i className="mr-2 mdi mdi-account-multiple-outline mr-10"></i>&nbsp;ReSeller Information</div>
        </Row>
        <Row className="toolbar up-card-box justify-content-center">
          <div className="col-md-3" style={{ textAlign: "center" }}>
            <img src={avatarUrl != "" ? avatarUrl == "/storage/avatar.jpg" ? avatar : baseImgURL + avatarUrl : avatar} className="img-company"></img>
            <Form>
              <FormGroup>
                {/* <Input type="file" name="file" id="exampleFile" onChange={withChange(this, this.onDrop)} /> */}
                <ImageUploader
                  withIcon={false}
                  buttonText='Choose images'
                  onChange={withChange(this, this.onDrop)}
                  imgExtension={['.jpg', '.gif', '.png', '.gif']}
                  maxFileSize={5242880}
                  singleImage={true}
                />
              </FormGroup>
            </Form>
          </div>
          <form className="col-md-7" onSubmit={this.onSave} onChangeCapture={markChanged(this)}>
            {resellerMissingNotice(this.state.missing) && (
              <div className="alert alert-warning reseller-missing">{resellerMissingNotice(this.state.missing)}</div>
            )}
            <Row className="company-text-area">
              <label className="col-md-3 control-label">First name</label>
              <div className="col-md-9">
                <input className="location-text-input" name="name" type="text" value={this.state.nameValue} onChange={withChange(this, this.handleChange)} required></input>
              </div>
            </Row>
            <Row className="company-text-area">
              <label className="col-md-3 control-label">Last name</label>
              <div className="col-md-9">
                <input className="location-text-input" name="sname" type="text" value={this.state.snameValue} onChange={withChange(this, this.handleChange)} required></input>
              </div>
            </Row>
            <Row className="company-text-area">
              <label className="col-md-3 control-label">Company name</label>
              <div className="col-md-9">
                <input className="location-text-input" name="reseller_company" type="text" value={this.state.companyValue} onChange={withChange(this, this.handleChange)}
                  placeholder="The reseller's own business" required></input>
              </div>
            </Row>
            <Row className="company-text-area">
              <label className="col-md-3 control-label">Country</label>
              <div className="col-md-9">
                <Select
                  className="select-country"
                  styles={styles}
                  options={this.state.options}
                  value={this.state.countryValue}
                  onChange={withChange(this, this.changeCountry)}
                  components={{
                    Option: CountryFlagSelectOption,
                    ValueContainer: CountryFlagValueContainer
                  }}
                />
              </div>
            </Row>
            {/* Only when the country has several time zones; otherwise set from the country without a word */}
            <TimeZoneField row
              country={this.state.countryValue ? this.state.countryValue.value : null}
              value={this.state.timeValue ? this.state.timeValue.value : null}
              onChange={(zone) => this.setState({ timeValue: zone ? { value: zone, label: zone } : '' })}
            />
            <Row className="company-text-area">
              <label className="col-md-3 control-label">Email</label>
              <div className="col-md-9">
                <input className="location-text-input" name="email" type="text" value={this.state.emailValue} onChange={withChange(this, this.handleChange)} required></input>
              </div>
            </Row>
            <Row className="company-text-area">
              <label className="col-md-3 control-label">Phone</label>
              <div className="col-md-9">
                {/* The flag and dialling code follow the Country field while the box is empty; a number typed
                    with its own +code keeps its own flag */}
                <PhoneInput
                  placeholder="Enter phone number"
                  value={this.state.phoneValue}
                  defaultCountry={this.state.countryValue && this.state.countryValue.value ? this.state.countryValue.value : undefined}
                  international
                  className='phonenumber-input'
                  onChange={withChange(this, this.setPhoneNumber)} />
              </div>
            </Row>
            <Row className="company-text-area">
              <label className="col-md-3 control-label">Password</label>
              <div className="col-md-9">
                <input className="location-text-input" name="password" type="text" value={this.state.password} onChange={withChange(this, this.handleChange)}
                  placeholder={resellerId != null ? 'Leave blank to keep the current password' : 'At least 6 characters'}
                  required={resellerId == null}></input>
              </div>
            </Row>
            <div className="height-10"></div>
            <EditButtons changed={this.state.formChanged} onExit={this.exitForm} />
            <div className="height-10"></div>
          </form>
        </Row>
      </Card>
      <Modal isOpen={this.state.showAlert} toggle={this.toggle}>
        {/* <ModalHeader toggle={this.alertToggle}>Alert Modal</ModalHeader> */}
        <ModalBody className="alert-body">
          <i className="mdi mdi-alert-circle ft-60"></i>
          <h2>{this.state.alertMessage}</h2>
          <div className="height-10"></div>
          <FormGroup>
            <Button color="secondary" style={{ width: '100px' }} className="ml-1" onClick={this.toggle}>Cancel</Button>
            <span>&nbsp;&nbsp;</span>
            <Button color="primary" style={{ width: '100px' }} onClick={this.toggle}>Ok</Button>
          </FormGroup>
        </ModalBody>
      </Modal>
    </div>
  }
}


export default CompanyView;
